import { Box, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

export const CalendarThemeWrapper = ({ children }: Props) => {
  const theme = useTheme();

  return (
    <Box
      id="calendar-theme-wrapper"
      sx={
        {
          "--mui-font": theme.typography.fontFamily,
          "--mui-text": theme.palette.text.primary,
          "--mui-text-secondary": theme.palette.text.secondary,
          "--mui-divider": theme.palette.divider,
          "--mui-primary": theme.palette.primary.main,
          "--mui-primary-light": theme.palette.primary.light,
          "--mui-background": theme.palette.background.default,
          "--mui-background-paper": theme.palette.background.paper,

          /* Color variables for calendar events used in `calendar.css` */
          "--talent-calendar-worktime-bg": alpha(
            theme.palette.primary.light,
            0.9,
          ),
          "--talent-calendar-worktime-bg-hover": alpha(
            theme.palette.primary.light,
            1,
          ),
          "--talent-calendar-worktime-text": "#ffffff",

          "--talent-calendar-unavailability-full-bg": alpha(
            theme.palette.error.main,
            0.9,
          ),
          "--talent-calendar-unavailability-full-bg-hover": alpha(
            theme.palette.error.main,
            1,
          ),
          "--talent-calendar-unavailability-full-text": "#ffffff",

          "--talent-calendar-unavailability-partial-bg": alpha(
            theme.palette.warning.light,
            0.9,
          ),
          "--talent-calendar-unavailability-partial-bg-hover": alpha(
            theme.palette.warning.light,
            1,
          ),
          "--talent-calendar-unavailability-partial-text":
            theme.palette.text.primary,

          flex: 1,
          minHeight: 0,
          height: "100%",
          display: "flex",
          flexDirection: "column",
        } as any
      }
    >
      {children}
    </Box>
  );
};
